<template>
  <div class="phone-mockup">
    <div class="phone-mockup__frame">
      <div class="phone-mockup__notch" />
      <div class="phone-mockup__screen">
        <div class="app-preview">
          <div class="app-preview__header">
            <span class="app-preview__logo">
              <span class="app-preview__logo-go">Go</span>TrustJP
            </span>
            <div class="app-preview__search">搜索课程/老师/资讯</div>
          </div>

          <div class="app-preview__banner">
            <div class="app-preview__banner-left">
              <span class="app-preview__clip">📎</span>
              <div>
                <p class="app-preview__banner-title">新用户首单优惠</p>
                <p class="app-preview__banner-sub">NEW USER OFFER</p>
              </div>
            </div>
            <div class="app-preview__banner-right">
              <p class="app-preview__banner-label">最高抵扣</p>
              <p class="app-preview__banner-amount">¥200</p>
            </div>
          </div>

          <div class="app-preview__section">
            <div class="app-preview__section-header">
              <span>课程推荐</span>
              <span>›</span>
            </div>
            <div class="app-preview__card">
              <div class="app-preview__card-top">
                <span class="app-preview__card-title">理工 | 空间情报 · 研究计划书</span>
                <span class="app-preview__card-price">¥4000</span>
              </div>
              <div class="app-preview__tags">
                <span class="app-preview__tag">研究计划书</span>
                <span class="app-preview__tag">包含套磁指导</span>
              </div>
              <p class="app-preview__card-desc">本课程针对日本大学院理工类空间情报方向...</p>
            </div>
          </div>

          <div class="app-preview__section">
            <div class="app-preview__section-header">
              <span>名师推荐</span>
              <span>›</span>
            </div>
            <div class="app-preview__card app-preview__card--teacher">
              <div class="app-preview__teacher-avatar" />
              <div>
                <p class="app-preview__teacher-name">张三老师 ✓</p>
                <p class="app-preview__teacher-bio">东京大学空间情报学博士后，5年辅导经验...</p>
              </div>
            </div>
          </div>

          <div class="app-preview__section">
            <div class="app-preview__section-header">
              <span>考学资讯</span>
              <span>›</span>
            </div>
            <div class="app-preview__card">
              <p class="app-preview__article-title">2025年日本留学签证政策最新解读</p>
              <p class="app-preview__article-desc">日本入管局近日发布了2025年度留学签证新政策...</p>
            </div>
          </div>

          <div class="app-preview__nav">
            <div class="app-preview__nav-item app-preview__nav-item--active">
              <span>⌂</span>
              <span>首页</span>
            </div>
            <div class="app-preview__nav-item">
              <span>📚</span>
              <span>课程</span>
            </div>
            <div class="app-preview__nav-item">
              <span>💬</span>
              <span>消息</span>
            </div>
            <div class="app-preview__nav-item">
              <span>👤</span>
              <span>我的</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneMockup',
}
</script>

<style scoped>
.phone-mockup {
  display: flex;
  justify-content: center;
}

.phone-mockup__frame {
  width: 280px;
  background: #1a1a1a;
  border-radius: 36px;
  padding: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  position: relative;
}

.phone-mockup__notch {
  width: 100px;
  height: 24px;
  background: #1a1a1a;
  border-radius: 0 0 16px 16px;
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.phone-mockup__screen {
  background: var(--color-bg);
  border-radius: 28px;
  overflow: hidden;
  height: 520px;
}

.app-preview {
  padding: 40px 10px 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-preview__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 0 4px;
}

.app-preview__logo {
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.app-preview__logo-go {
  position: relative;
}

.app-preview__logo-go::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  background: var(--color-accent);
}

.app-preview__search {
  flex: 1;
  background: var(--color-white);
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 9px;
  color: var(--color-text-light);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-preview__banner {
  display: flex;
  align-items: center;
  background: var(--color-bg-light);
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  gap: 8px;
}

.app-preview__banner-left {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
}

.app-preview__clip {
  font-size: 12px;
}

.app-preview__banner-title {
  font-size: 9px;
  font-weight: 700;
}

.app-preview__banner-sub {
  font-size: 7px;
  color: var(--color-text-light);
}

.app-preview__banner-right {
  text-align: center;
  border-left: 1px dashed var(--color-border);
  padding-left: 8px;
}

.app-preview__banner-label {
  font-size: 7px;
  color: var(--color-text-secondary);
}

.app-preview__banner-amount {
  font-size: 16px;
  font-weight: 800;
  color: var(--color-accent);
}

.app-preview__section {
  margin-bottom: 8px;
}

.app-preview__section-header {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  font-weight: 700;
  margin-bottom: 6px;
  padding: 0 2px;
  color: var(--color-text-light);
}

.app-preview__card {
  background: var(--color-white);
  border-radius: 8px;
  padding: 8px;
  box-shadow: var(--shadow-card);
}

.app-preview__card-top {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin-bottom: 4px;
}

.app-preview__card-title {
  font-size: 8px;
  font-weight: 700;
  line-height: 1.3;
}

.app-preview__card-price {
  font-size: 9px;
  font-weight: 700;
  color: var(--color-accent);
  white-space: nowrap;
}

.app-preview__tags {
  display: flex;
  gap: 3px;
  margin-bottom: 4px;
}

.app-preview__tag {
  font-size: 6px;
  background: var(--color-tag-bg);
  color: var(--color-text-secondary);
  padding: 2px 4px;
  border-radius: 2px;
}

.app-preview__card-desc {
  font-size: 7px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.app-preview__card--teacher {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.app-preview__teacher-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d5d5d5;
  flex-shrink: 0;
}

.app-preview__teacher-name {
  font-size: 8px;
  font-weight: 700;
  margin-bottom: 2px;
}

.app-preview__teacher-bio {
  font-size: 7px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.app-preview__article-title {
  font-size: 8px;
  font-weight: 700;
  margin-bottom: 3px;
}

.app-preview__article-desc {
  font-size: 7px;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.app-preview__nav {
  margin-top: auto;
  display: flex;
  background: var(--color-primary);
  border-radius: 12px 12px 0 0;
  padding: 8px 0 6px;
}

.app-preview__nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 7px;
  color: rgba(255, 255, 255, 0.5);
}

.app-preview__nav-item--active {
  color: var(--color-white);
}

.app-preview__nav-item span:first-child {
  font-size: 12px;
}

@media (min-width: 768px) {
  .phone-mockup__frame {
    width: 320px;
  }

  .phone-mockup__screen {
    height: 580px;
  }
}
</style>
